import { configureStore } from "@reduxjs/toolkit";
import ordersReducer from "./slicers/ordersSlicer";
import tasksReducer from "./slicers/tasksSlicer";
import contactsReducer from "./slicers/contactsSlicer";

export const ordersContext = configureStore({
	reducer: {
		orders: ordersReducer,
		tasks: tasksReducer,
		contacts: contactsReducer,
	},
});

export type OrdersState = ReturnType<typeof ordersContext.getState>;
export type OrdersDispatch = typeof ordersContext.dispatch;

export type TasksState = ReturnType<typeof ordersContext.getState>;
export type TasksDispatch = typeof ordersContext.dispatch;

export type ContactsState = ReturnType<typeof ordersContext.getState>;
export type ContactsDispatch = typeof ordersContext.dispatch;
